export default "__VITE_ASSET__DAaRlYu$__"